import Analytics from './Analytics'
import { tealiumUTag } from './services/TealiumUTag'
import { PAGE_CONTENT_TYPES, SITE_SECTIONS } from './constants'

export const analytics = new Analytics(tealiumUTag)

export {
  PAGE_CONTENT_TYPES,
  SITE_SECTIONS,
}
